<template>
    <AppCard>
        <div class="flex flex-col h-full">
            <div class="h-24 flex items-center">
                <img v-if="brand.image" :data-src="brand.image" class="object-fit max-w-[100px] mx-auto lazy">
            </div>

            <h3 class="text-black font-bold mb-4 text-lg">{{ brand.name }}</h3>

            <p class="mb-3">Popular tyres:</p>

            <ul class="p-0 mb-4">
                <li class="underline" v-for="product of brand.products">
                    <InertiaLink :href="route('products.show', [product])">
                        {{ product.name }}
                    </InertiaLink>
                </li>
            </ul>

            <AppButton :href="route('brands.show', brand)" class="mb-3 w-full mt-auto">
                View more
            </AppButton>

            <p class="text-center">{{ toLocaleString(brand.reviews_count) }} reviews</p>
        </div>
    </AppCard>
</template>

<script>
import AppCard from "@/Components/AppCard";
import AppButton from "@/Components/AppButton";
import {InertiaLink} from "@inertiajs/inertia-vue3";
import {FontAwesomeIcon} from "@fortawesome/vue-fontawesome";
import LazyLoad from "vanilla-lazyload";
import Numbers from "@/Mixins/Utilities/Numbers";

export default {
    components: {AppButton, AppCard, InertiaLink, FontAwesomeIcon, LazyLoad},
    mixins: [Numbers],
    props: {
        brand: Object
    },
    mounted() {
        let lazyLoadInstance = new LazyLoad({});
    },
    computed: {},
};
</script>

<style scoped>

</style>
